import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

const deleteLink = (assetId: string) => FetchPromise.delete(`${CMS_API_ROOT_URL}/link/${assetId}`);

export const useDeleteLink = () => useMutation(deleteLink);
